import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Server_URL } from 'src/environments/environment';
import { environment } from 'src/environments/environment.prod';


@Injectable({
  providedIn: 'root'
})
export class DonationtypeService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }
  
  GetDonationType():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/DonationType/Get`);
  }

  DeleteDonationType(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/DonationType/Delete?id=${id}`);
  }

  CreateDonationType(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/DonationType/Create`,data);
  }
  UpdateDonationType(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/DonationType/Update`,data)
  }
}
